import { Directive, Output, OnInit, OnDestroy, EventEmitter, Renderer2, ElementRef } from '@angular/core';

@Directive({
  selector: '[select-click]'
})
export class SelectClickDirective implements OnInit, OnDestroy{
  private unsubscrive: any;

  @Output('select-click') selectClickEvent = new EventEmitter();

  constructor(
    private readonly renderer: Renderer2,
    private readonly element: ElementRef
  ) { }

  ngOnInit() {
    this.unsubscrive = this.renderer.listen(this.element.nativeElement, 'click', event => {
      if(event.ctrlKey || event.shiftKey) {
        event.preventDefault();
        event.stopPropagation();
        document.getSelection().removeAllRanges();

        this.selectClickEvent.emit(event);
      } else if((event.target.tagName !== 'EDITABLE' && event.target.tagName !== 'INPUT') ) {
        if(event.target.tagName !== 'TD') { //per evitare raddoppiamento dell'evento click in apertura editor su tabella traduzioni
          event.stopPropagation();
        } 
        this.selectClickEvent.emit(event);
      }
    });
  }

  ngOnDestroy() {
    if(!this.unsubscrive) {
      return;
    }
    this.unsubscrive();
  }
}